import { render, staticRenderFns } from "./view_marketing.vue?vue&type=template&id=6f1a5a9e&scoped=true&"
import script from "./view_marketing.vue?vue&type=script&lang=js&"
export * from "./view_marketing.vue?vue&type=script&lang=js&"
import style0 from "./view_marketing.vue?vue&type=style&index=0&id=6f1a5a9e&prod&scoped=true&lang=css&"
import style1 from "./view_marketing.vue?vue&type=style&index=1&id=6f1a5a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a5a9e",
  null
  
)

export default component.exports